/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { onboardingStepsSchema } from '../enums/onboarding-steps-schema';

export const completeOnboardingStepV1ResponseDataSchema = z.object({
  steps: onboardingStepsSchema,
});

export type ICompleteOnboardingStepV1ResponseData = z.infer<
  typeof completeOnboardingStepV1ResponseDataSchema
>;

export const completeOnboardingStepV1ResponseSchema = createApiResponseSchema(
  completeOnboardingStepV1ResponseDataSchema,
) as z.ZodSchema<IAPI<ICompleteOnboardingStepV1ResponseData>>;

export type ICompleteOnboardingStepV1Response = IAPI<ICompleteOnboardingStepV1ResponseData>;
